/* eslint-disable max-len */
import {
    chakra,
    Flex,
    Text,
    Box
} from '@chakra-ui/react';

import threeEssentialsBg from '../../../assets/images/three_essentials_bg.svg';
import threeEssentialsHover from '../../../assets/images/three_essentials_bg_hover.svg';

export const ProductSwitcherWrapper = chakra(Flex, {
    label: 'product-switcher-wrapper',
    baseStyle: { bgColor: 'white' }
});

export const Container = chakra(Flex, {
    label: 'product-switcher-container',
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        justifyContent: 'center',
        alignItems: 'center',
        w: '67px',
        h: '60px',
        cursor: 'pointer'
    }
});

export const ProductSwitcherPopper = chakra(Flex, {
    label: 'product-switcher-popper',
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        position: 'absolute',
        top: '55px',
        left: '10px',
        zIndex: '9999',
        flexDirection: 'column',
        w: '458px',
        borderRadius: '8px',
        bgColor: '#fff',
        p: '16px',
        border: '1px solid #E7EAEF',
        boxShadow: '0px 8px 10px -6px rgba(0, 0, 0, 0.10), 0px 20px 25px -5px rgba(0, 0, 0, 0.10);'
    }
});

export const MenuItem = chakra(Flex, {
    label: 'product-switcher-menu-item',
    baseStyle: {
        position: 'relative',
        flexDirection: 'column',
        w: '100%',
        h: '130px',
        borderRadius: '8px',
        p: '12px 16px',
        border: '2.5px solid transparent',
        mt: '8px',
        mb: '8px',
        cursor: 'pointer',
        backgroundImage: threeEssentialsBg,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        _last: { mb: 0 },
        _hover: {
            boxShadow: '0px 2px 4px -2px rgba(0, 0, 0, 0.10), 0px 4px 6px -1px rgba(0, 0, 0, 0.10)',
            backgroundImage: threeEssentialsHover,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        }
    }
});

export const Title = chakra(Text, {
    label: 'product-switcher-title',
    baseStyle: {
        color: 'neutral.700',
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: '28px',
        letterSpacing: 0
    }
});

export const Description = chakra(Title, {
    label: 'product-switcher-description',
    baseStyle: {
        fontSize: '15px',
        fontWeight: 400,
        lineHeight: '24px',
        mt: '8px'
    }
});

export const Logos = chakra(Flex, {
    label: 'product-switcher-logos',
    baseStyle: { mb: '8px' }
});

export const HeaderAppButton = chakra(Box, {
    label: 'product-switcher-header-app',
    baseStyle: {
        backgroundColor: 'primary.700',
        h: '60px',
        minWidth: '70px',
        borderBottom: '1px solid',
        borderColor: 'primary.700'
    }
});

export const Logo = chakra(Flex, {
    label: 'product-switcher-logo',
    baseStyle: {
        w: '71px',
        maxW: '105px',
        h: '40px',
        alignItems: 'center',
        justifyContent: 'center',
        mr: '16px'
    }
});
